// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'vue-ydui/dist/ydui.base.css';
import './utils/flexible.js';
import './sass/main.scss';
import {
    Button,
    ButtonGroup
} from 'vue-ydui/dist/lib.px/button';
Vue.component(Button.name, Button);
Vue.component(ButtonGroup.name, ButtonGroup);

import {
    NavBar,
    NavBarBackIcon,
    NavBarNextIcon
} from 'vue-ydui/dist/lib.px/navbar';
Vue.component(NavBar.name, NavBar);
Vue.component(NavBarBackIcon.name, NavBarBackIcon);
Vue.component(NavBarNextIcon.name, NavBarNextIcon);

//import {CellGroup, CellItem} from 'vue-ydui/dist/lib.rem/cell';
import {
    CellGroup,
    CellItem
} from 'vue-ydui/dist/lib.px/cell';

Vue.component(CellGroup.name, CellGroup);
Vue.component(CellItem.name, CellItem);

import {
    DateTime
} from 'vue-ydui/dist/lib.px/datetime';

Vue.component(DateTime.name, DateTime);
import {
    CitySelect
} from 'vue-ydui/dist/lib.px/cityselect';

Vue.component(CitySelect.name, CitySelect);

import {
    ActionSheet
} from 'vue-ydui/dist/lib.px/actionsheet';

Vue.component(ActionSheet.name, ActionSheet);
import {
    Confirm,
    Alert,
    Toast,
    Notify,
    Loading
} from 'vue-ydui/dist/lib.px/dialog';
import { Input } from 'vue-ydui/dist/lib.px/input';

Vue.component(Input.name, Input);
import { Popup } from 'vue-ydui/dist/lib.px/popup';

Vue.component(Popup.name, Popup);

import { CheckBox, CheckBoxGroup } from 'vue-ydui/dist/lib.px/checkbox';

Vue.component(CheckBox.name, CheckBox);
Vue.component(CheckBoxGroup.name, CheckBoxGroup);
Vue.config.productionTip = false
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'

// import vconsole from 'vconsole';
// const Vconsole = new vconsole();

Vue.use(MuseUI)
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    }
})
Vue.prototype.$dialog = {
    confirm: Confirm,
    alert: Alert,
    toast: Toast,
    notify: Notify,
    loading: Loading,
};

import { Tab, TabPanel } from 'vue-ydui/dist/lib.rem/tab';

Vue.component(Tab.name, Tab);
Vue.component(TabPanel.name, TabPanel);

import { Radio, RadioGroup } from 'vue-ydui/dist/lib.rem/radio';
/* 使用px：import {Radio, RadioGroup} from 'vue-ydui/dist/lib.px/radio'; */

Vue.component(Radio.name, Radio);
Vue.component(RadioGroup.name, RadioGroup);

import { FlexBox, FlexBoxItem } from 'vue-ydui/dist/lib.rem/flexbox';
/* 使用px：import {FlexBox, FlexBoxItem} from 'vue-ydui/dist/lib.px/flexbox'; */

Vue.component(FlexBox.name, FlexBox);
Vue.component(FlexBoxItem.name, FlexBoxItem);

// 注册一个全局自定义指令 `不允许输入空格&*%等特殊字符`
Vue.directive('filterSpecialChar', {
    update: function (el, { value, modifiers }, vnode) {
            try {
                //此处可以debug看看el具体值是什么,这里演示的是原生控件input,如果是使用element中的<el-input />标签,需要通过 el.children[0] 拿到原生input.
                    if(!el.value){
                       return false;
                     }
                    el.value = el.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, "");
                    el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
            } catch (e) {
            }
    }
})



// WEBPACK FOOTER //
// ./src/main.js